module.exports = __webpack_public_path__ + "static/media/login-background-min.a48c0ca5.png";